export default function Modal({ title, titleColor = "cyan", onClose, children, footer, wide = false }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className={wide ? 'modal-box modal-box-wide' : 'modal-box'}>
        <div className="modal-header">
          <span className={`modal-title techno ${titleColor}`}>{title}</span>
          <button className="modal-close" onClick={onClose}>
            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
